













import { upload } from '@/api/system'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class HelloWorld extends Vue {
  @Prop() public value!: string

  loading = false

  /**
   * Upload file
   * @param file
   */
  async onBeforeUpload (file: File) {
    console.log(file)
    this.loading = true
    const form = new FormData()
    form.append('file', file)
    const { data } = await upload(form)
    this.$emit('input', data.url)
    this.loading = false
    return false
  }
}
